import React from 'react';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const socialLinks = [
    {
      name: 'GitHub',
      icon: (
        <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
          <path d="M12 .5C5.73.5.5 5.73.5 12c0 5.08 3.29 9.4 7.86 10.94.57.1.78-.25.78-.55 0-.27-.01-1-.02-1.95-3.2.7-3.88-1.54-3.88-1.54-.52-1.33-1.27-1.68-1.27-1.68-1.04-.71.08-.7.08-.7 1.15.08 1.75 1.18 1.75 1.18 1.02 1.74 2.67 1.24 3.32.95.1-.74.4-1.24.72-1.53-2.55-.29-5.24-1.28-5.24-5.72 0-1.26.45-2.29 1.18-3.1-.12-.29-.52-1.46.11-3.04 0 0 .96-.31 3.14 1.18a10.8 10.8 0 0 1 2.86-.38c.97.01 1.95.13 2.86.38 2.18-1.49 3.14-1.18 3.14-1.18.63 1.58.23 2.75.11 3.04.73.81 1.18 1.84 1.18 3.1 0 4.45-2.7 5.42-5.27 5.71.41.35.78 1.04.78 2.09 0 1.51-.01 2.73-.01 3.1 0 .3.21.66.79.55A11.52 11.52 0 0 0 23.5 12C23.5 5.73 18.27.5 12 .5z" />
        </svg>
      ),
      url: 'https://github.com/noamjanco'
    },
    {
      name: 'LinkedIn',
      icon: (
        <svg viewBox="0 0 448 512" aria-hidden="true" focusable="false">
          <path d="M100.28 448H7.4V148.9h92.88zm-46.44-340.6a53.93 53.93 0 1 1 53.93-53.9 53.94 53.94 0 0 1-53.93 53.9zM447.9 448h-92.68V302.4c0-34.7-12.4-58.4-43.48-58.4-23.72 0-37.86 16-44.1 31.4-2.27 5.5-2.84 13.2-2.84 20.9V448h-92.7s1.24-242.7 0-268h92.7v38c-.19.3-.43.6-.62.9h.62v-.9c12.3-19 34.24-46.1 83.3-46.1 60.8 0 106.34 39.7 106.34 125.1V448z" />
        </svg>
      ),
      url: 'https://www.linkedin.com/in/noam-janco-29b996182/'
    },
    {
      name: 'Email',
      icon: (
        <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
          <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4-8 5-8-5V6l8 5 8-5v2z" />
        </svg>
      ),
      url: 'mailto:noamjanco@gmail.com'
    },
    {
      name: 'Resume',
      icon: (
        <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zM13 3.5L18.5 9H14a1 1 0 0 1-1-1V3.5zM8 12h8v2H8v-2zm0 4h8v2H8v-2z" />
        </svg>
      ),
      url: '/NoamJancoCV2023_2.pdf'
    }
  ];

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3 className="footer-logo">NJ</h3>
            <p className="footer-tagline">Building digital experiences</p>
          </div>
          
          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul className="footer-links">
              <li><a href="#home">Home</a></li>
              <li><a href="#about">About</a></li>
              <li><a href="#projects">Projects</a></li>
              <li><a href="#skills">Skills</a></li>
              <li><a href="#contact">Contact</a></li>
                <li><a href="/NoamJancoCV2023_2.pdf" target="_blank" rel="noopener noreferrer">Resume (PDF)</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Connect</h4>
            <div className="social-links">
              {socialLinks.map((link, index) => (
                <a
                  key={index}
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-link"
                  title={link.name}
                >
                  <span>{link.icon}</span>
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} Noam Janco. All rights reserved.</p>
          <p className="footer-made">Made with ❤️ and React</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
